//TODO switch all components to be lazy loaded as best practice from vuerouter docs
import { Layout, List, Create, Details, Project } from '@/views/projects'
import { Invoices, InvoiceForm, InvoiceCreate } from '@/views/projects/invoices'
import { Postech, PostechForm, PostechCreate } from '@/views/projects/postech'
import ProjectFiles from '@/views/projects/files/Project-files.vue'
//import { useProjectStore } from '@/stores';

//const projectStore = useProjectStore();

export default {
  path: 'projects',
  //name: 'projects_list',
  //component: Layout,
  component: () => import('@/views/projects/Layout.vue'),
  children: [
    { path: '', redirect: { name: 'projects_list' } },
    { path: 'list', name: 'projects_list', component: List },
    { path: 'createproject', name: 'create_project', component: Create },
    {
      path: ':projectId',
      component: () => import('@/views/projects/Project.vue'),
      //component: () => {return Project} ,
      //props: (route) => {
      //  return {
      //    ...route.params,
      //    ...{ projectId: Number.parseInt(route.params.projectId, 10) || undefined }
      //  }
      //},
      children: [
        //{ path : '', component: Basic },
        {
          path: 'details',
          name: 'project_details',
         // component: Details,
          component: () => import('@/views/projects/Project-details.vue'),
          // props: (route) => {
          //    return { ...route.params, ...{ projectId: Number.parseInt(route.params.projectId, 10) || undefined } }
          // }
        },

        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: 'invoices',
          name: 'project_invoices',
          meta: {
            authRequired: 'true',
            groups: ['admin', 'standard']
          },
          //component: Invoices,
          component: () => import('@/views/projects/invoices/Project-invoices.vue'),
          //props: (route) => {
           //             return {
           //                 ...route.params, ...{ projectId: Number.parseInt(route.params.projectId, 10) || undefined }
                            //projectId: Number.parseInt(route.params.projectId, 10) || undefined
           //             }
           //         },
          children: [
            // { path: '', redirect : { name: 'project_invoice'}, props : { invoiceId : useProjectStore().currentProject.invoices[0].id}},
            {
              path: ':invoiceId',
              name: 'project_invoice',
              //component: InvoiceForm,
              component : () => import("@/views/projects/invoices/Invoice-form.vue"),
             // props: (route) => {
             //   return { ...route.params, ...{ invoiceId: route.params.invoiceId || undefined } }
                //return { invoiceId : route.params.invoiceId || undefined }
             // }
              /*
                            children: [
                              {
                                path: 'print',
                                name: 'print_invoice',
                                component: ()=> import('../components/SMP-invoice.vue'),
                                props: (route) =>{
                                  return { ...route.params, ...{ invoiceId: route.params.invoiceId || undefined } }
                                }
                              }
                            ]*/
            },
            {
              path: 'create',
              name: 'create_invoice',
              component: InvoiceCreate,
             // props: (route) => {
             //   return { projectId: Number.parseInt(route.params.projectId, 10) || undefined }
            //  }
            }
          ]
        },

        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: 'postech',
          name: 'project_postechs',
          component: Postech,
          /*props: (route) => {
                        return {
                            //...route.params, ...{ projectId: Number.parseInt(route.params.projectId, 10) || undefined }
                            projectId: Number.parseInt(route.params.projectId, 10) || undefined
                        }
                    },*/
          children: [
            {
              path: ':postechId',
              name: 'project_postech',
              component: PostechForm,
              props: (route) => {
                return {
                  ...route.params,
                  ...{ postechId: Number.parseInt(route.params.postechId, 10) || undefined }
                }
                //return { postechId: Number.parseInt(route.params.postechId, 10) || undefined }
              }
            },
            {
              path: 'create',
              name: 'create_postech',
              component: PostechCreate,
              props: (route) => {
                return { projectId: Number.parseInt(route.params.projectId, 10) || undefined }
              }
            }
          ]
        },

        {
          path: 'files',
          name: 'project_files',
          component: ProjectFiles,
          props: (route) => {
            return { projectId: Number.parseInt(route.params.projectId, 10) || undefined }
          }
        }
      ]
    }
    // { path: 'add', component: AddEdit },
    // { path: 'edit/:id', component: AddEdit }
  ]
  /*,
async beforeRouteEnter(to, from, next) {
    try {
      console.log("....projects.routes beforeRouteEnter, attempting to set current project");
      let projectId = to.params.projectId;
      await projectStore.setCurrentProject(projectId);
      //onst post = await getPost(to.params.id)
      // `setPost` is a method defined below
      //next(vm => vm.setPost(post))
    } catch (err) {
      // `setError` is a method defined below
      //next(vm => vm.setError(err))
    }
  }*/
}
